import { useQuery } from '@tanstack/vue-query';
import type { Language } from '@ilteducation/content-ref-data-types';
import { computed } from 'vue';
import { getAllRefData } from '@/data-provider/refDataProvider';

export const useRefLanguages = () => {
  const { data, isPending } = useQuery({
    queryKey: ['ref-languages'],
    queryFn: async () => {
      const languages = (await getAllRefData('languages')) as Language[];

      return languages.sort((a: Language, b: Language) => a.language.localeCompare(b.language));
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    languages: data,
    isLoading: isPending,
  };
};

export const useLanguageLabel = () => {
  const { languages } = useRefLanguages();

  const getLanguageLabel = computed(() => (languageCode: string) => {
    if (!languages.value) {
      return languageCode;
    }

    const language = languages.value.find((l: Language) => l.languageCode === languageCode);
    return language ? language.language : languageCode;
  });

  return {
    getLanguageLabel,
  };
};
